.container-loader{
  cursor: wait;
  z-index: 100;
  position: absolute;
  top: 50%;
  left: 50%;
  background-color: var(--black-75);
  transform: translate(-50%, -50%);
  display: grid;
  place-content: center;
  width: 100vw;
  height: 100vh;
  transition: linear;
}
.cargando{
  width: 150px;
  height: 40px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  margin: 0 auto;
}
.texto-cargando{
  padding-top:20px
}
.cargando span{
  width: 100%;
  font-size: 20px;
  text-transform: uppercase;
  text-align: center;
}
.pelotas {
  width: 35px;
  height: 35px;
  background-color: var(--primary);
  animation: salto .5s alternate infinite;
  border-radius: 50%
}
.pelotas:nth-child(2) {
  animation-delay: .18s;
}
.pelotas:nth-child(3) {
  animation-delay: .37s;
}
@keyframes salto {
  from {
    transform: scaleX(1.25);
  }
  to{
    transform:
    translateY(-50px) scaleX(1);
  }
}